/* istanbul ignore next: todo: test */
export function translate(key, replaces) {
    //eslint-disable-next-line prefer-named-capture-group
    return key.replace(/\{\{([^}]+)\}\}/gi, function (_match, k) {
        return replaces[k.trim()] || '';
    });
}
//# sourceMappingURL=Translate.js.map